
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/psd-to-sketch",
      function () {
        return require("private-next-pages/converter/psd-to-sketch.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/psd-to-sketch"])
      });
    }
  